// extracted by mini-css-extract-plugin
module.exports = {"newsletterGradient":"footer_newsletterGradient__S1zxz"};